import * as Actions from '../actions';
import * as moment from 'moment';
import { reorderArray } from 'main/components/helpers';

const initialState = {
    isLessonLoaded: false,
    repullLesson: false,
    copiedLesson: false,
    lessonList: [],
    listLoaded: false,
    moduleListLoadedAfterSave: true,
    NewLessonName: '',
    moduleListSearchable: {
        companies: [],
        labels: []
    },
    currentLesson: {
        LessonName: '',
        LessonDescription: '',
        Active: 0,
        assetList: [],
        newLessonAssets: [],
        Unscheduled: 0,
        CreateAuthID: 0,
        LastEditAuthID: 0,
        CreationDate: '',
        LastEditDate: '',
        IsLocked: 0,
        LockedByAuthID: 0,
        labels: [],
        lesson_id: 0,
        CopiedFromID: 0
    },
    editInfo: {
        CreationDate: '',
        LastEditDate: '',
        CreateAuthEmail: '',
        LastEditAuthEmail: '',
    },
    allAssignments: [],
    allQuizzes: [],
    currentLessonAssignmentList: [],
    currentLessonQuizList: [],
    currentLessonModuleList: [],
    unscheduledEventList: [],
    unscheduledDisplayOrder: 1,
    lesson_on_schedule: [],
    courses: [],
    deleteAllowed: false,
    companies: [],
    allCompanies: []
}

const lessonReducer = function (state = initialState, action) {
    switch (action.type) {
        case (Actions.UPDATE_LESSON_LOADED):
            {
                if (action.payload) {
                    return {
                        ...state,
                        isLessonLoaded: action.payload,
                    }
                } else {
                    // reset to default state
                    return {
                        ...initialState
                    }
                }
            }
        case (Actions.ACTIVATE_LESSON):
            {
                return {
                    ...state,
                    currentLesson: {
                        ...state.currentLesson,
                        Active: 1
                    }
                }
            }
        case (Actions.GET_LESSON):
            {
                return {
                    ...state,
                    currentLesson: {
                        ...state.currentLesson,
                        ...action.payload,
                        lesson_loaded: true
                    },
                    NewLessonName: action.payload.LessonName + ' - Copy',
                };
            }

        case (Actions.DELETE_LESSON):
            {
                return {
                    ...state,
                    currentLesson: { lesson_loaded: false },
                    lessonList: state.lessonList.filter((lesson) => lesson.lesson_id !== action.payload) // Removes Corresponding Lesson in LessonList
                };
            }
        case (Actions.CLEAR_SCHEDULE):
            {
                const change = { Unscheduled: state.currentLesson.Unscheduled === 0 ? 1 : 0 }
                return {
                    ...state,
                    currentLessonAssignmentList: [],
                    currentLessonQuizList: [],
                    unscheduledEventList: [],
                    currentLesson: { ...state.currentLesson, ...change }
                }
            }
        case (Actions.COMPANY_UPDATE_SEARCH):
            {
                return {
                    ...state,
                    companySearch: action.payload
                }
            }
        case (Actions.TOGGLE_COMPANY):
            {
                if (action.payload.action_type === 'ADD') {
                    let newCompany = state.allCompanies.filter((c) => c.id === action.payload.company.id)
                    return {
                        ...state,
                        companies: state.companies.concat(newCompany)
                    }
                }
                else {
                    return {
                        ...state,
                        companies: state.companies.filter((c) => c.id !== action.payload.company.id)
                    }
                }
            }
        case (Actions.GET_LESSON_LIST):
            {
                return {
                    ...state,
                    listLoaded: true,
                    lessonList: action.payload.lessonList.lessonList,
                    lessonListSearchable: {
                        companies: action.payload.lessonList.searchData.companies,
                        labels: action.payload.lessonList.searchData.labels
                    },
                    lessonListLoadedAfterSave: action.payload.call_location === 'list' ? state.lessonListLoadedAfterSave : true
                };
            }
        case (Actions.UPDATE_LESSON_LIST_LOADED):
            {
                return {
                    ...state,
                    lessonListLoadedAfterSave: action.payload
                }
            }

        case (Actions.GET_LESSON_ASSET_LIST):
            {
                const l_id = state.currentLesson.lesson_id;

                if (l_id === 0) {
                    const newAssetList = state.currentLesson.newLessonAssets.concat(action.payload.assetInsertResponse);
                    const new_asset_ids = newAssetList.map(a => a.insert_id);
                    const filtered_assets = action.payload.responseData.filter(a => new_asset_ids.includes(a.header.asset_id));

                    return {
                        ...state,
                        currentLesson: {
                            ...state.currentLesson,
                            assetList: filtered_assets,
                            newLessonAssets: state.currentLesson.newLessonAssets.concat(action.payload.assetInsertResponse)
                        }
                    }
                }
                else {
                    return {
                        ...state,
                        currentLesson: {
                            ...state.currentLesson,
                            assetList: action.payload.responseData,
                            newLessonAssets: []
                        }
                    }
                }

            }
        case (Actions.GET_ALL_ASSIGNMENTS):
            {
                return {
                    ...state,
                    allAssignments: action.payload.assignmentList
                        .filter(a => a.Active === 1)
                        .sort((a, b) => {
                            const titleA = a.AssignmentName.toLowerCase();
                            const titleB = b.AssignmentName.toLowerCase();

                            if (titleA < titleB) return -1;
                            if (titleA > titleB) return 1;
                            return 0;
                        }),
                }
            }

        case (Actions.GET_ALL_QUIZZES):
            {
                return {
                    ...state,
                    allQuizzes: action.payload.quizList
                        .filter(q => q.Active === 1)
                        .sort((a, b) => {
                            const titleA = a.QuizName.toLowerCase();
                            const titleB = b.QuizName.toLowerCase();

                            if (titleA < titleB) return -1;
                            if (titleA > titleB) return 1;
                            return 0;
                        }),
                }
            }

        case (Actions.UPDATE_LESSON_FORM):
            {
                return {
                    ...state,
                    currentLesson: { ...state.currentLesson, ...action.payload }
                }
            }
        case (Actions.GET_RELATED_DATA):
            {
                const {
                    quizzes,
                    assignments,
                    courses,
                    edit_info,
                    lesson_on_schedule,
                    deleteAllowed,
                    unscheduled_event_list,
                    copiedLesson
                } = action.payload;

                return {
                    ...state,
                    currentLessonQuizList: quizzes.map((event_info) => { return { ...event_info, event_id: 'quiz_new_' + event_info.quiz_id } }),
                    currentLessonAssignmentList: assignments.map((event_info) => { return { ...event_info, event_id: 'assignment_new_' + event_info.assignment_id } }),
                    unscheduledEventList: unscheduled_event_list,
                    courses: courses,
                    editInfo: edit_info,
                    lesson_on_schedule: lesson_on_schedule,
                    deleteAllowed: deleteAllowed,
                    companies: action.payload.companies,
                    allCompanies: action.payload.allCompanies,
                    copiedLesson
                }
            }

        case (Actions.GET_COMPANY_LIST):
            {
                return {
                    ...state,
                    allCompanies: action.payload.map(c => {
                        return {
                            ...c,
                            label: c.CompanyName,
                            id: c.company_id
                        }
                    })
                }
            }

        case (Actions.SET_UNSCHEDULED_EVENT_RELATION):
            {
                const { event_relation, event_id } = action.payload;

                return {
                    ...state,
                    unscheduledEventList: state.unscheduledEventList.map((event_info) => {
                        if (event_info.event_id === event_id) {
                            return {
                                ...event_info,
                                event_relation: event_relation,
                            }
                        } else {
                            return event_info
                        }
                    })
                }
            }

        case (Actions.UPDATE_EVENT):
            {
                if (action.payload.event.eventType === 'assignment') {
                    return {
                        ...state,
                        currentLessonAssignmentList: state.currentLessonAssignmentList.map(a => {
                            if (a.assignment_id === action.payload.event.rel_id) {
                                a.StartTime = moment(action.payload.start).format('HH:mm:ss');
                                a.EndTime = action.payload.event.end ?
                                    moment(action.payload.end).format('HH:mm:ss')
                                    :
                                    moment(action.payload.end).add('minutes', 60).format('HH:mm:ss')
                                a.lesson_id = action.payload.event.model_id
                                // a.lesson_assignment_rel_id ? action.payload.event.id : null
                            }
                            return a
                        })
                    }
                }
                else {
                    return {
                        ...state,
                        currentLessonQuizList: state.currentLessonQuizList.map(q => {
                            if (q.quiz_id === action.payload.event.rel_id) {
                                q.StartTime = moment(action.payload.start).format('HH:mm:ss');
                                // q.EndTime = moment(action.payload.end).format('HH:mm:ss');
                                q.EndTime = action.payload.event.end ?
                                    moment(action.payload.end).format('HH:mm:ss')
                                    :
                                    moment(action.payload.end).add('minutes', 60).format('HH:mm:ss');
                                q.lesson_id = action.payload.event.model_id
                                // a.lesson_assignment_rel_id ? action.payload.event.id : null
                            }
                            return q
                        })
                    }
                }

            }
        /** This checks if the assignment/quiz relation already exists. If so, it appends nothing to the relation list  */
        case (Actions.CHECK_EVENT_ADD):
            {
                if (action.payload.eventType === 'assignment') {
                    let existingRelataion = state.currentLessonAssignmentList.filter((a) => a.assignment_id === action.payload.rel_id)
                    existingRelataion = existingRelataion.length === 0 ? {
                        AssignmentName: action.payload.title,
                        Active: 1,
                        AssignmentDescription: action.payload.desc,
                        DisplayOrder: 0,
                        StartTime: action.payload.start,
                        EndTime: action.payload.end,
                        assignment_id: action.payload.rel_id,
                        lesson_assignment_rel_id: null,
                        lesson_id: action.payload.model_id,
                        Color: action.payload.Color
                    } : []
                    return {
                        ...state,
                        currentLessonAssignmentList: state.currentLessonAssignmentList.concat(existingRelataion),
                        unscheduledEventList: action.payload.DisplayOrder ?
                            state.unscheduledEventList.filter(e => e.id != action.payload.id) : state.unscheduledEventList
                    }
                }
                else {
                    let existingRelataion = state.currentLessonQuizList.filter((q) => q.quiz_id === action.payload.rel_id)
                    existingRelataion = existingRelataion.length === 0 ? {
                        QuizName: action.payload.title,
                        Active: 1,
                        QuizDescription: action.payload.desc,
                        DisplayOrder: 0,
                        StartTime: action.payload.start,
                        EndTime: action.payload.end,
                        quiz_id: action.payload.rel_id,
                        lesson_quiz_rel_id: null,
                        lesson_id: action.payload.model_id
                    } : []
                    return {
                        ...state,
                        currentLessonQuizList: state.currentLessonQuizList.concat(existingRelataion),
                        unscheduledEventList: action.payload.DisplayOrder ?
                            state.unscheduledEventList.filter(e => e.id != action.payload.id) : state.unscheduledEventList
                    }
                }
            }

        case (Actions.ADD_UNSCHEDULED_EVENT):
            {
                const { source, destination, event_type, event_info } = action.payload;

                const newUnscheduledEventList = state.unscheduledEventList;
                newUnscheduledEventList.splice(destination.index, 0, {
                    title: event_info.title,
                    id: event_info.id,
                    desc: event_info.desc,
                    DisplayOrder: state.unscheduledDisplayOrder,
                    eventType: event_info.eventType,
                    rel_id: event_info.rel_id,
                    Color: event_info.Color,
                    event_id: event_info.event_id,
                    event_relation: [],
                });

                return {
                    ...state,
                    currentLessonAssignmentList: state.currentLessonAssignmentList.map((assignment_info) => {
                        if (event_type === 'assignment' && assignment_info.assignment_id === event_info.rel_id) {
                            return {
                                ...assignment_info,
                                StartTime: null,
                                EndTime: null,
                                event_relation: [],
                            }
                        } else {
                            return assignment_info;
                        }
                    }),
                    currentLessonQuizList: state.currentLessonQuizList.map((quiz_info) => {
                        if (event_type === 'quiz' && quiz_info.quiz_id === event_info.rel_id) {
                            return {
                                ...quiz_info,
                                StartTime: null,
                                EndTime: null,
                                event_relation: [],
                            }
                        } else {
                            return quiz_info;
                        }
                    }),
                    unscheduledEventList: newUnscheduledEventList,
                    unscheduledDisplayOrder: state.unscheduledDisplayOrder + 1
                }
            }

        case (Actions.MOVE_UNSCHEDULED_EVENT):
            {
                const { source, destination, event_type, event_info } = action.payload;

                return {
                    ...state,
                    unscheduledEventList: reorderArray(state.unscheduledEventList, source.index, destination.index)
                        .reduce((acc, curr) => {
                            return [
                                ...acc,
                                {
                                    ...curr,
                                    event_relation: curr.event_relation.filter((rel_event_id) => {
                                        // Filter out events that come after current index
                                        return acc.filter((acc_info) => acc_info.event_id === rel_event_id).length > 0
                                    })
                                }
                            ]
                        }, [])
                }
            }

        case (Actions.REMOVE_UNSCHEDULED_EVENT):
            {
                const { source, destination, event_type, event_info } = action.payload;

                return {
                    ...state,
                    unscheduledEventList: state.unscheduledEventList.filter((selected_event_info) => selected_event_info.event_id !== event_info.event_id),
                    currentLessonAssignmentList: state.currentLessonAssignmentList.filter((selected_event_info) => selected_event_info.event_id !== event_info.event_id),
                    currentLessonQuizList: state.currentLessonQuizList.filter((selected_event_info) => selected_event_info.event_id !== event_info.event_id),
                }
            }

        case (Actions.ADD_UNSCHEDULED_EVENT_OLD):
            // console.log(action.payload)
            // /**This checks if it is being dragged from the calendar, and doesn't let it go thru */
            // Early return if its already inthe unscheduled list
            if (action.payload.card) {
                return { ...state }
            }

            if (action.payload.start) {
                if (action.payload.eventType === 'assignment') {
                    return {
                        ...state,
                        currentLessonAssignmentList: state.currentLessonAssignmentList.map(a => {
                            if (a.assignment_id === action.payload.rel_id) {
                                return {
                                    ...a,
                                    StartTime: null,
                                    EndTime: null
                                }
                            }
                            return { ...a }
                        }),
                        unscheduledEventList: state.unscheduledEventList.concat(
                            {
                                title: action.payload.title,
                                id: action.payload.id,
                                DisplayOrder: state.unscheduledDisplayOrder,
                                eventType: action.payload.eventType,
                                rel_id: action.payload.rel_id,
                                Color: action.payload.Color
                            }),
                        unscheduledDisplayOrder: state.unscheduledDisplayOrder + 1
                    }
                }
                else {
                    return {
                        ...state,
                        currentLessonQuizList: state.currentLessonQuizList.map(q => {
                            if (q.quiz_id === action.payload.rel_id) {
                                return {
                                    ...q,
                                    StartTime: null,
                                    EndTime: null
                                }
                            }
                            return { ...q }
                        }),
                        unscheduledEventList: state.unscheduledEventList.concat(
                            {
                                title: action.payload.title,
                                id: action.payload.id,
                                DisplayOrder: state.unscheduledDisplayOrder,
                                eventType: action.payload.eventType,
                                rel_id: action.payload.rel_id,
                                Color: '#0074D9'
                            }),
                        unscheduledDisplayOrder: state.unscheduledDisplayOrder + 1
                    }
                }
                return {
                    ...state,

                }
            }

            // Take the event object and check if it has a relationship already with the lesson
            // If it does, don't add anything to currentLessonAssignmentList
            // If it doesnt, Add a redux relationship between lesson and quiz/assignment

            if (action.payload.eventType === 'assignment') {
                let existingAssignmentRel = state.currentLessonAssignmentList.filter((a) => a.assignment_id === action.payload.rel_id)
                existingAssignmentRel = existingAssignmentRel.length === 0 ? {
                    AssignmentName: action.payload.title,
                    Active: 1,
                    AssignmentDescription: action.payload.desc,
                    DisplayOrder: state.unscheduledDisplayOrder,
                    StartTime: null,
                    EndTime: null,
                    assignment_id: action.payload.rel_id,
                    lesson_assignment_rel_id: null,
                    lesson_id: action.payload.model_id,
                    Color: action.payload.Color
                } : []
                return {
                    ...state,
                    currentLessonAssignmentList: state.currentLessonAssignmentList.concat(existingAssignmentRel),
                    unscheduledEventList: state.unscheduledEventList.concat(
                        {
                            title: existingAssignmentRel.AssignmentName,
                            id: existingAssignmentRel.lesson_assignment_rel_id || 'assignment_id_' + existingAssignmentRel.assignment_id,
                            DisplayOrder: existingAssignmentRel.DisplayOrder,
                            eventType: action.payload.eventType,
                            rel_id: action.payload.rel_id,
                            Color: action.payload.Color
                        }),
                    unscheduledDisplayOrder: state.unscheduledDisplayOrder + 1
                }
            }
            else {
                let x = state.currentLessonQuizList.filter((q) => q.quiz_id === action.payload.rel_id)
                x = x.length === 0 ? {
                    QuizName: action.payload.title,
                    Active: 1,
                    QuizDescription: action.payload.desc,
                    DisplayOrder: state.unscheduledDisplayOrder,
                    StartTime: null,
                    EndTime: null,
                    quiz_id: action.payload.rel_id,
                    lesson_quiz_rel_id: null,
                    lesson_id: action.payload.model_id
                } : []
                return {
                    ...state,
                    currentLessonQuizList: state.currentLessonQuizList.concat(x),
                    unscheduledEventList: state.unscheduledEventList.concat(
                        {
                            title: x.QuizName,
                            id: x.quiz_assignment_rel_id || 'quiz_id_' + x.quiz_id,
                            DisplayOrder: x.DisplayOrder,
                            eventType: action.payload.eventType,
                            rel_id: action.payload.rel_id,
                            Color: '#0074D9'
                        }),
                    unscheduledDisplayOrder: state.unscheduledDisplayOrder + 1
                }
            }
        case (Actions.MOVE_CARD):
            {
                return {
                    ...state,
                    unscheduledEventList: state.unscheduledEventList.map((e, index) => {
                        if (index === action.payload.dragIndex) {
                            return {
                                ...e,
                                DisplayOrder: action.payload.hoverIndex + 1
                            }
                        }
                        else if (index === action.payload.hoverIndex) {
                            return {
                                ...e,
                                DisplayOrder: action.payload.dragIndex + 1
                            }
                        }
                        else {
                            return e
                        }
                    })
                }

            }
        case (Actions.PREPARE_DISPLAY_ORDERS):
            {
                let lastValue = state.unscheduledEventList.length + 1
                return {
                    ...state,
                    unscheduledEventList: state.unscheduledEventList.map((e, index) => {
                        return {
                            ...e,
                            DisplayOrder: index + 1
                        }
                    }),
                    unscheduledDisplayOrder: lastValue

                }
            }
        case (Actions.REMOVE_EVENT_FROM_CALENDAR):
            {
                if (action.payload.eventType === 'assignment') {
                    return {
                        ...state,
                        currentLessonAssignmentList: state.currentLessonAssignmentList.filter((a) => a.assignment_id !== action.payload.rel_id),
                        unscheduledEventList: state.unscheduledEventList.filter((e) => e.eventType + e.rel_id !== 'assignment' + action.payload.rel_id)
                    }
                }
                else {
                    return {
                        ...state,
                        currentLessonQuizList: state.currentLessonQuizList.filter((q) => q.quiz_id !== action.payload.rel_id),
                        unscheduledEventList: state.unscheduledEventList.filter((q) => q.eventType + q.rel_id !== 'quiz' + action.payload.rel_id)
                    }
                }
            }
        case (Actions.LOCK_LESSON):
            {
                return {
                    ...state,
                    currentLesson: {
                        ...state.currentLesson,
                        IsLocked: 1,
                        LockedByAuthID: action.payload
                    }
                }
            }

        case (Actions.UNLOCK_LESSON):
            {
                return {
                    ...state,
                    currentLesson: {
                        ...state.currentLesson,
                        IsLocked: 0,
                        LockedByAuthID: 0
                    }
                }
            }
        case (Actions.UPDATE_ASSET_NAME):
            {
                return {
                    ...state,
                    currentLesson: {
                        ...state.currentLesson,
                        assetList: state.currentLesson.assetList.map(asset => {
                            if (asset.header.asset_id === action.payload.asset_id) {
                                return {
                                    ...asset,
                                    header: {
                                        ...asset.header,
                                        AssetNewName: action.payload.newName,
                                        UneditedNewName: action.payload.saved ? action.payload.newName : asset.header.UneditedNewName
                                    }
                                }
                            }
                            return asset
                        })
                    }
                }
            }
        case (Actions.UPDATE_NEW_LESSON_NAME):
            {
                return {
                    ...state,
                    NewLessonName: action.payload
                }
            }
        case (Actions.TOGGLE_LESSON_REPULL):
            {
                return {
                    ...state,
                    repullLesson: action.payload
                }
            }
        default:
            {
                return state;
            }
    }
}

export default lessonReducer;


// WEBPACK FOOTER //
// src/main/content/lesson/store/reducers/lesson.reducer.js